!function(w, d) {

var y = 120,
    c = 'topbar-shrink',
		h = d.documentElement,
		el = d.querySelector('.topbar');

if(el == null) return;

w.addEventListener('scroll', update);
update();

function update(e) {

	var scroll = w.pageYOffset || h.scrollTop;
	var cl = h.classList;

	if (scroll > y)
		cl.add(c)
	else
		cl.remove(c)
}

}(window, document)
